import React from 'react';
import Images from './Images'
import PropTypes from 'prop-types';

const ImagesList = ({ images }) => {
    return (
        <div className="col-12 p-5 row">
            {images.map(image =>
                (                   
                    <Images
                        key={image.id}
                        image={image}
                    />
                ))}
        </div>
    );
}
ImagesList.proptTypes = {
    images: PropTypes.array.isRequired
}
export default ImagesList;